
// import { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { signupUser } from "../../lib/AuthApi";
// import { getClasses } from "../../lib/ClassApi";
// import PasswordInput from "./components/PasswordInput";
// import Logo from "../../components/common/Logo";

// const RegisterUser = () => {
//   const navigate = useNavigate();

//   const [classList, setClassList] = useState([]);
//   const [schoolId, setSchoolId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const initialFormState = {
//     username: "",
//     password: "",
//     confirmPassword: "",
//     firstName: "",
//     lastName: "",
//     mobile: "",
//     email: "",
//     birthDate: "",
//     schoolName: 11,
//     medium: "",
//     state: "",
//     city: "",
//     className: "",
//     board: "",
//     Sections: "",
//   };

//   const [form, setForm] = useState(initialFormState);

//   const inputClass =
//     "w-full h-12 md:h-14 bg-[#f7f7f7] border border-[#bfb8b0] rounded-md px-4 text-base md:text-lg outline-none text-[#1d1d1d] placeholder:text-[#b7afa8] focus:border-[#6c54ab]";

//   // ================= Fetch Classes =================

//   useEffect(() => {
//     const fetchConfig = async () => {
//       try {
//         const [classRes, schoolRes] = await Promise.all([
//           getClasses(),
//           fetch("/json/School_Id.json"),
//         ]);

//         if (classRes.success && Array.isArray(classRes.data)) {
//           setClassList(classRes.data);
//         }

//         if (schoolRes.ok) {
//           const schoolData = await schoolRes.json();
//           const configuredSchoolId = Array.isArray(schoolData)
//             ? schoolData?.[0]?.SchoolID
//             : schoolData?.SchoolID;

//           if (configuredSchoolId != null) {
//             setSchoolId(Number(configuredSchoolId));
//           }
//         }
//       } catch (err) {
//         console.log("Config load error:", err);
//       }
//     };

//     fetchConfig();
//   }, []);

//   // ================= Handle Change =================

//   const handleChange = (field, value) => {
//     setForm((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   // ================= Handle Signup =================

//   const handleSignUp = async (e) => {
//     e.preventDefault();

//     if (!form.username || !form.password) {
//       return setError("All fields are required");
//     }

//     if (form.password !== form.confirmPassword) {
//       return setError("Passwords do not match");
//     }

//     const payload = {
//       username: form.username,
//       password: form.password,
//       confirmPassword: form.confirmPassword,
//       firstName: form.firstName,
//       lastName: form.lastName,
//       email: form.email,
//       mobileNumber: form.mobile,
//       CityName: form.city,
//       StateName: form.state,
//       dateOfBirth: form.birthDate,
//       schoolId: Number(schoolId) || 11,
//       //Number(form.schoolName),
//       RoleId: 3,
//       UserRoles: ["student"],

//       classSections: [
//         {
//           classId: Number(form.className),
//           sections: [Number(form.Sections)],
//           status: "A",
//         },
//       ],

//       IsActive: true,
//       ModifiedBy: 13,
//     };

//     try {
//       setLoading(true);
//       setError("");
//       setSuccess("");

//       const res = await signupUser(payload);


//       if (!res?.data?.isSuccess) {
//         setError(res?.data?.displayMessage || "Signup failed");
//         return;
//       }

//       setSuccess(res?.data?.displayMessage || "Your account has been created successfully");

//       setForm(initialFormState);

//       setTimeout(() => {
//         navigate("/login");
//       }, 1500);

//     } catch (err) {
//       console.log(err);

//       setError(
//         err?.response?.data?.message ||
//         err?.message ||
//         "Signup failed"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-secondary flex flex-col items-center px-4 py-4 md:px-6 md:py-8">

//       <Logo />

//       <div className="w-full max-w-6xl mx-auto px-2 sm:px-4 mt-4 md:mt-8">

//         {/* Header */}
//         <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 mb-6">
//           <h2 className="text-2xl md:text-3xl font-semibold">
//             Sign Up
//           </h2>

//           <p className="text-sm">
//             Already have an account?{" "}
//             <Link
//               to="/login"
//               className="text-primary"
//             >
//               Login
//             </Link>
//           </p>
//         </div>

//         {/* Success */}
//         {success && (
//           <p className="text-green-600 text-sm mb-4 font-medium">
//             {success}
//           </p>
//         )}

//         {/* Error */}
//         {error && (
//           <p className="text-red-500 text-sm mb-4">
//             {error}
//           </p>
//         )}

//         {/* Form */}
//         <form
//           onSubmit={handleSignUp}
//           className="
// grid
//     grid-cols-1
//     lg:grid-cols-2
//     gap-4
//     lg:gap-8
// "
//         >

//           {/* LEFT */}
//           <div className="space-y-3 md:space-y-4">

//             <input
//               type="text"
//               placeholder="Username / Email / Mobile*"
//               value={form.username}
//               onChange={(e) =>
//                 handleChange("username", e.target.value)
//               }
//               className={inputClass}
//             />

//             <PasswordInput
//               value={form.password}
//               onChange={(e) =>
//                 handleChange("password", e.target.value)
//               }
//               placeholder="Password*"
//               className={inputClass}
//             />

//             <PasswordInput
//               value={form.confirmPassword}
//               onChange={(e) =>
//                 handleChange(
//                   "confirmPassword",
//                   e.target.value
//                 )
//               }
//               placeholder="Re-type Password*"
//               className={inputClass}
//             />

//             {/* <input
//               type="text"
//               placeholder="School name"
//               value={form.schoolName}
//               onChange={(e) =>
//                 handleChange("schoolName", e.target.value)
//               }
//               className="input"
//             /> */}



//             <input
//               type="text"
//               placeholder="Enter Medium*"
//               value={form.medium}
//               onChange={(e) =>
//                 handleChange("medium", e.target.value)
//               }
//               className={inputClass}
//             />



//             <input
//               type="text"
//               placeholder="Enter State*"
//               value={form.state}
//               onChange={(e) =>
//                 handleChange("state", e.target.value)
//               }
//               className={inputClass}
//             />

//             <input
//               type="text"
//               placeholder="Enter city*"
//               value={form.city}
//               onChange={(e) =>
//                 handleChange("city", e.target.value)
//               }
//               className={inputClass}
//             />

//             {/* <select
//               value={form.state}
//               onChange={(e) =>
//                 handleChange("state", e.target.value)
//               }
//               className="input"
//             >
//               <option value="">State*</option>
//               <option value="Delhi">Delhi</option>
//             </select> */}

//             {/* <select
//               value={form.city}
//               onChange={(e) =>
//                 handleChange("city", e.target.value)
//               }
//               className="input"
//             >
//               <option value="">City*</option>
//               <option value="Delhi">Delhi</option>
//             </select> */}
//           </div>

//           {/* RIGHT */}
//           <div className="space-y-3 md:space-y-4">

//             <input
//               type="text"
//               placeholder="First name*"
//               value={form.firstName}
//               onChange={(e) =>
//                 handleChange("firstName", e.target.value)
//               }
//               className={inputClass}
//             />

//             <input
//               type="text"
//               placeholder="Last name*"
//               value={form.lastName}
//               onChange={(e) =>
//                 handleChange("lastName", e.target.value)
//               }
//               className={inputClass}
//             />

//             <input
//               type="text"
//               placeholder="Mobile no.*"
//               value={form.mobile}
//               onChange={(e) =>
//                 handleChange("mobile", e.target.value)
//               }
//               className={inputClass}
//             />

//             <input
//               type="email"
//               placeholder="Email ID*"
//               value={form.email}
//               onChange={(e) =>
//                 handleChange("email", e.target.value)
//               }
//               className={inputClass}
//             />

//             <input
//               type="date"
//               placeholder="DOB"
//               value={form.birthDate}
//               onChange={(e) =>
//                 handleChange("birthDate", e.target.value)
//               }
//               className={inputClass}
//             />

//             <select
//               value={form.className}
//               onChange={(e) =>
//                 handleChange("className", e.target.value)
//               }
//               className={inputClass}
//             >
//               <option value="">Class*</option>

//               {classList.map((cls) => (
//                 <option
//                   key={cls.id}
//                   value={cls.id}
//                 >
//                   {cls.classname}
//                 </option>
//               ))}
//             </select>

//             <select
//               value={form.Sections}
//               onChange={(e) =>
//                 handleChange("Sections", e.target.value)
//               }
//               className={inputClass}
//             >
//               <option value="">Section*</option>
//               <option value="36">A</option>
//             </select>
//           </div>

//           {/* Submit */}
//           <div className="lg:col-span-2">
//             <button
//               type="submit"
//               disabled={loading}
//               className="btn-primary w-full h-12 md:h-14 text-base md:text-lg disabled:opacity-60"
//             // className="btn-primary w-full h-12 md:h-14 text-base md:text-lg disabled:opacity-60n-primary w-full disabled:opacity-60"
//             >
//               {loading ? "Creating..." : "Sign Up"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default RegisterUser;

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signupUser } from "../../lib/AuthApi";
import { getClasses } from "../../lib/ClassApi";
import PasswordInput from "./components/PasswordInput";

const RegisterUser = () => {
  const navigate = useNavigate();

  // =========================================================
  // STATES
  // =========================================================

  const [classList, setClassList] = useState([]);
  const [schoolId, setSchoolId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [profileImage, setProfileImage] = useState(null);

  const [declarations, setDeclarations] = useState({
    terms: false,
    education: false,
    notifications: false,
  });

  // =========================================================
  // FORM
  // =========================================================

  const initialFormState = {
    username: "",
    password: "",
    confirmPassword: "",

    firstName: "",
    lastName: "",

    mobile: "",
    email: "",

    birthDate: "",
    schoolName: "",

    medium: "",
    preferredBatch: "",

    state: "",
    city: "",

    className: "",
    board: "",

    Sections: "",
  };

  const [form, setForm] = useState(initialFormState);

  // =========================================================
  // FETCH CONFIG
  // =========================================================

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const classResponse = await getClasses();

        console.log("Class API response:", classResponse);

        if (
          classResponse?.success &&
          Array.isArray(classResponse.data)
        ) {
          setClassList(classResponse.data);
        } else if (Array.isArray(classResponse?.data)) {
          setClassList(classResponse.data);
        } else if (Array.isArray(classResponse)) {
          setClassList(classResponse);
        } else {
          setClassList([]);
        }

        try {
          const schoolResponse = await fetch(
            "/json/School_Id.json"
          );

          if (schoolResponse.ok) {
            const schoolData =
              await schoolResponse.json();

            const configuredSchoolId = Array.isArray(
              schoolData
            )
              ? schoolData?.[0]?.SchoolID
              : schoolData?.SchoolID;

            if (configuredSchoolId != null) {
              setSchoolId(
                Number(configuredSchoolId)
              );
            }
          }
        } catch (schoolError) {
          console.warn(
            "School config could not be loaded:",
            schoolError
          );
        }
      } catch (err) {
        console.error(
          "Class config load error:",
          err
        );

        setError(
          "Unable to load registration configuration. Please refresh the page."
        );
      }
    };

    fetchConfig();
  }, []);

  // =========================================================
  // CLASS HELPERS
  // =========================================================

  const getClassId = (cls) => {
    return (
      cls?.id ??
      cls?.classId ??
      cls?.ClassID ??
      cls?.ID ??
      cls?.Id
    );
  };

  const getClassName = (cls) => {
    return (
      cls?.classname ??
      cls?.className ??
      cls?.ClassName ??
      cls?.name ??
      cls?.Name ??
      `Class ${getClassId(cls) ?? ""}`
    );
  };

  // =========================================================
  // CHANGE
  // =========================================================

  const handleChange = (field, value) => {
    setForm((previous) => ({
      ...previous,
      [field]: value,
    }));

    setError("");
    setSuccess("");
  };

  // =========================================================
  // DECLARATION
  // =========================================================

  const handleDeclarationChange = (
    field,
    checked
  ) => {
    setDeclarations((previous) => ({
      ...previous,
      [field]: checked,
    }));

    setError("");
  };

  // =========================================================
  // PROFILE IMAGE
  // =========================================================

  const handleProfileImage = (event) => {
    const file = event.target.files?.[0];

    if (!file) {
      setProfileImage(null);
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      setError(
        "Profile image must be less than 2 MB."
      );

      event.target.value = "";
      setProfileImage(null);
      return;
    }

    if (!file.type.startsWith("image/")) {
      setError(
        "Please select a valid image file."
      );

      event.target.value = "";
      setProfileImage(null);
      return;
    }

    setProfileImage(file);
    setError("");
  };

  // =========================================================
  // FIND CLASS 9
  // =========================================================

  const findClassNine = () => {
    return classList.find((cls) => {
      const className = String(
        getClassName(cls)
      )
        .toLowerCase()
        .trim();

      return (
        className === "class 9" ||
        className === "9" ||
        className === "9th" ||
        className.includes("class 9") ||
        className.includes("9th")
      );
    });
  };

  // =========================================================
  // DEMO
  // =========================================================

  const handleFillDemo = () => {
    const classNine = findClassNine();

    const demoClassId =
      getClassId(classNine);

    if (!demoClassId) {
      setError(
        "Class list is still loading. Please wait and try again."
      );
      return;
    }

    setForm({
      username: "akansha.k9",

      password: "Akansha@123",

      confirmPassword: "Akansha@123",

      firstName: "Akansha",

      lastName: "Kapoor",

      mobile: "9876543210",

      email: "rohit.kapoor@example.com",

      birthDate: "2011-06-15",

      schoolName:
        "Greenfield High School",

      medium: "English",

      preferredBatch:
        "MWF — Mon, Wed, Fri",

      state: "Delhi",

      city: "New Delhi",

      className: String(demoClassId),

      board: "CBSE",

      Sections: "36",
    });

    setDeclarations({
      terms: true,
      education: true,
      notifications: false,
    });

    setProfileImage(null);

    setError("");
    setSuccess("");
  };

  // =========================================================
  // RESET
  // =========================================================

  const handleReset = () => {
    setForm(initialFormState);

    setDeclarations({
      terms: false,
      education: false,
      notifications: false,
    });

    setProfileImage(null);

    setError("");
    setSuccess("");
  };

  // =========================================================
  // CUSTOM VALIDATION
  // =========================================================

  const validateForm = () => {
    if (!form.username.trim()) {
      return "Please enter username.";
    }

    if (form.username.trim().length < 3) {
      return "Username must contain at least 3 characters.";
    }

    if (!form.password) {
      return "Please enter password.";
    }

    if (form.password.length < 6) {
      return "Password must contain at least 6 characters.";
    }

    if (!form.confirmPassword) {
      return "Please re-type your password.";
    }

    if (
      form.password !==
      form.confirmPassword
    ) {
      return "Passwords do not match.";
    }

    if (!form.firstName.trim()) {
      return "Please enter first name.";
    }

    if (!/^[A-Za-z ]+$/.test(form.firstName.trim())) {
      return "First name can contain letters only.";
    }

    if (!form.lastName.trim()) {
      return "Please enter last name.";
    }

    if (!/^[A-Za-z ]+$/.test(form.lastName.trim())) {
      return "Last name can contain letters only.";
    }

    if (!form.mobile.trim()) {
      return "Please enter mobile number.";
    }

    if (!/^[0-9]{10}$/.test(form.mobile.trim())) {
      return "Please enter a valid 10-digit mobile number.";
    }

    if (!form.email.trim()) {
      return "Please enter email ID.";
    }

    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(form.email.trim())) {
      return "Please enter a valid email ID.";
    }

    if (!form.birthDate) {
      return "Please select birth date.";
    }

    if (!form.schoolName.trim()) {
      return "Please enter school name.";
    }

    if (!form.className) {
      return "Please select class.";
    }

    const classId = Number(
      form.className
    );

    if (
      !Number.isInteger(classId) ||
      classId <= 0
    ) {
      return "Please select a valid class.";
    }

    if (!form.board) {
      return "Please select board.";
    }

    if (!form.medium) {
      return "Please select medium of instruction.";
    }

    if (!form.preferredBatch) {
      return "Please select preferred batch.";
    }

    if (!form.state.trim()) {
      return "Please enter state.";
    }

    if (!form.city.trim()) {
      return "Please enter city.";
    }

    if (!form.Sections) {
      return "Please select section.";
    }

    const sectionId = Number(
      form.Sections
    );

    if (
      !Number.isInteger(sectionId) ||
      sectionId <= 0
    ) {
      return "Please select a valid section.";
    }

    if (!declarations.terms) {
      return "Please accept the terms and conditions.";
    }

    if (!declarations.education) {
      return "Please confirm educational usage permission.";
    }

    return "";
  };

  // =========================================================
  // SUBMIT
  // =========================================================

  const handleSignUp = async (event) => {
    /*
      IMPORTANT:
      Do NOT use event.preventDefault() before browser
      native validation.

      Browser checks required/type/email/etc first.
    */

    if (!event.currentTarget.checkValidity()) {
      return;
    }

    event.preventDefault();

    setError("");
    setSuccess("");

    const validationError =
      validateForm();

    if (validationError) {
      setError(validationError);
      return;
    }

    const classId = Number(
      form.className
    );

    const sectionId = Number(
      form.Sections
    );

    const payload = {
      username: form.username.trim(),

      password: form.password,

      confirmPassword:
        form.confirmPassword,

      firstName:
        form.firstName.trim(),

      lastName:
        form.lastName.trim(),

      email:
        form.email.trim(),

      mobileNumber:
        form.mobile.trim(),

      CityName:
        form.city.trim(),

      StateName:
        form.state.trim(),

      dateOfBirth:
        form.birthDate,

      schoolId:
        Number(schoolId) || 11,

      RoleId: 3,

      UserRoles: ["student"],

      classSections: [
        {
          classId: classId,

          sections: [
            sectionId
          ],

          status: "A",
        },
      ],

      IsActive: true,

      ModifiedBy: 13,
    };

    console.log(
      "REGISTER PAYLOAD:",
      JSON.stringify(
        payload,
        null,
        2
      )
    );

    try {
      setLoading(true);

      const response =
        await signupUser(payload);

      console.log(
        "REGISTER RESPONSE:",
        response
      );

      const responseData =
        response?.data;

      if (
        !responseData?.isSuccess
      ) {
        setError(
          responseData?.displayMessage ||
          responseData?.errorMessages?.[0] ||
          "Registration failed."
        );

        return;
      }

      setSuccess(
        responseData?.displayMessage ||
        "Your account has been created successfully."
      );

      setTimeout(() => {
        navigate("/login");
      }, 1500);
    } catch (err) {
      console.error(
        "Registration error:",
        err
      );

      const apiError =
        err?.response?.data;

      setError(
        apiError?.displayMessage ||
        apiError?.message ||
        apiError?.errorMessages?.[0] ||
        err?.message ||
        "Registration failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // TAILWIND
  // =========================================================

  const inputClass =
    "w-full h-[46px] sm:h-[48px] bg-white border border-[#ddd3c2] rounded-[10px] px-3 sm:px-4 text-[13px] sm:text-[14px] text-[#17144b] placeholder:text-[#aaa3b3] outline-none transition-all focus:border-[#4035c9] focus:ring-2 focus:ring-[#4035c9]/10";

  const selectClass =
    "w-full h-[46px] sm:h-[48px] bg-white border border-[#ddd3c2] rounded-[10px] px-3 sm:px-4 text-[13px] sm:text-[14px] text-[#17144b] outline-none cursor-pointer focus:border-[#4035c9] focus:ring-2 focus:ring-[#4035c9]/10";

  const labelClass =
    "block mb-1.5 text-[11px] sm:text-[12px] font-medium text-[#625c7d]";

  // =========================================================
  // UI
  // =========================================================

  return (
    <div className="min-h-screen min-h-[100dvh] bg-[#f7f3ea] text-[#17144b] overflow-x-hidden">

      <div className="w-full max-w-[1420px] mx-auto px-4 sm:px-6 lg:px-8">

        {/* =================================================
            HEADER
        ================================================= */}

        <header className="min-h-[88px] sm:min-h-[100px] flex items-center">

          <Link
            to="/"
            className="flex flex-col items-start w-fit"
          >
            <div className="text-[22px] sm:text-[26px] lg:text-[28px] leading-none font-extrabold tracking-[-1px] text-[#17144b]">
              Insta
              <span className="text-[#c75a38] italic">
                ED
              </span>{" "}
              Tuitions
            </div>

            <p className="mt-2 text-[8px] sm:text-[10px] tracking-[0.16em] text-[#8c84a0] uppercase">
              ONLINE TUITIONS · CLASSES 6–10
            </p>
          </Link>

        </header>

        {/* =================================================
            MAIN
        ================================================= */}

        <main className="w-full max-w-[1240px] mx-auto pb-12">

          {/* BACK */}

          <div className="mb-4">

            <button
              type="button"
              onClick={() => navigate(-1)}
              className="inline-flex items-center h-[30px] px-3 rounded-full border border-[#ddd3c2] bg-white text-[#17144b] text-[11px] font-medium hover:border-[#4035c9] transition"
            >
              ← Back
            </button>

          </div>

          {/* TITLE */}

          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-5">

            <div>

              <h1 className="text-[24px] sm:text-[28px] lg:text-[30px] font-bold leading-tight">
                Create your account
              </h1>

              <p className="mt-1 text-[12px] sm:text-[13px] text-[#6f6887]">
                Register as a student to continue with your classes.
              </p>

            </div>

            <p className="text-[12px] sm:text-[13px] text-[#6f6887]">

              Already have an account?{" "}

              <Link
                to="/login"
                className="text-[#4035c9] font-semibold hover:underline"
              >
                Login
              </Link>

            </p>

          </div>

          {/* SUCCESS */}

          {success && (
            <div className="mb-4 rounded-[10px] border border-green-200 bg-green-50 px-4 py-3 text-[12px] sm:text-[13px] font-medium text-green-700">
              {success}
            </div>
          )}

          {/* ERROR */}

          {error && (
            <div className="mb-4 rounded-[10px] border-l-[3px] border-[#d94b32] bg-[#fbecea] px-4 py-3 text-[12px] sm:text-[13px] text-[#17144b]">
              {error}
            </div>
          )}

          {/* =================================================
              FORM
          ================================================= */}

          <form
            onSubmit={handleSignUp}
            className="w-full bg-white border border-[#e8dfd0] rounded-[16px] shadow-[0_2px_8px_rgba(29,24,65,0.05)] overflow-hidden"
          >

            {/* PURPLE HEADER */}

            <div className="bg-[#4035c9] px-5 sm:px-7 py-4 sm:py-5 flex items-center justify-between">

              <div>

                <h2 className="text-[16px] sm:text-[18px] font-bold text-white">
                  Register | Create your profile
                </h2>

                <p className="mt-1 text-[10px] sm:text-[11px] text-white/75">
                  Enter your details to create your student account.
                </p>

              </div>

              <span className="hidden sm:flex w-8 h-8 rounded-full bg-white/10 items-center justify-center text-white">
                ↑
              </span>

            </div>

            {/* FORM BODY */}

            <div className="p-4 sm:p-6 lg:p-7">

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-3 sm:gap-x-4 gap-y-4">

                {/* USERNAME */}

                <div>

                  <label
                    htmlFor="username"
                    className={labelClass}
                  >
                    Username — email ID or mobile no. *
                  </label>

                  <input
                    id="username"
                    name="username"
                    type="text"
                    value={form.username}
                    placeholder="john.doe25"
                    onChange={(e) =>
                      handleChange(
                        "username",
                        e.target.value
                      )
                    }
                    className={inputClass}
                    required
                  />

                </div>

                {/* PROFILE IMAGE */}

                <div>

                  <label
                    htmlFor="profileImage"
                    className={labelClass}
                  >
                    Upload profile picture
                  </label>

                  <label
                    htmlFor="profileImage"
                    className="w-full h-[46px] sm:h-[48px] border border-[#ddd3c2] rounded-[10px] px-3 sm:px-4 flex items-center cursor-pointer bg-white hover:border-[#4035c9] transition"
                  >

                    <span className="text-[13px] sm:text-[14px] text-[#17144b] truncate">
                      {profileImage
                        ? profileImage.name
                        : "Choose an image — max 2 MB"}
                    </span>

                  </label>

                  <input
                    id="profileImage"
                    name="profileImage"
                    type="file"
                    accept="image/*"
                    onChange={handleProfileImage}
                    className="hidden"
                  />

                </div>

                {/* PASSWORD */}

                <div>

                  <label className={labelClass}>
                    Password *
                  </label>

                  <PasswordInput
                    value={form.password}
                    onChange={(e) =>
                      handleChange(
                        "password",
                        e.target.value
                      )
                    }
                    placeholder="Enter password"
                    className={inputClass}
                    required
                  />

                </div>

                {/* CONFIRM PASSWORD */}

                <div>

                  <label className={labelClass}>
                    Re-type password *
                  </label>

                  <PasswordInput
                    value={form.confirmPassword}
                    onChange={(e) =>
                      handleChange(
                        "confirmPassword",
                        e.target.value
                      )
                    }
                    placeholder="Re-enter password"
                    className={inputClass}
                    required
                  />

                </div>

                {/* FIRST NAME */}

                <div>

                  <label
                    htmlFor="firstName"
                    className={labelClass}
                  >
                    First name *
                  </label>

                  <input
                    id="firstName"
                    name="firstName"
                    type="text"
                    value={form.firstName}
                    placeholder="John"
                    onChange={(e) =>
                      handleChange(
                        "firstName",
                        e.target.value
                      )
                    }
                    className={inputClass}
                    required
                  />

                </div>

                {/* LAST NAME */}

                <div>

                  <label
                    htmlFor="lastName"
                    className={labelClass}
                  >
                    Last name *
                  </label>

                  <input
                    id="lastName"
                    name="lastName"
                    type="text"
                    value={form.lastName}
                    placeholder="Doe"
                    onChange={(e) =>
                      handleChange(
                        "lastName",
                        e.target.value
                      )
                    }
                    className={inputClass}
                    required
                  />

                </div>

                {/* MOBILE */}

                <div>

                  <label
                    htmlFor="mobile"
                    className={labelClass}
                  >
                    Mobile no. *
                  </label>

                  <input
                    id="mobile"
                    name="mobile"
                    type="tel"
                    inputMode="numeric"
                    maxLength={10}
                    value={form.mobile}
                    placeholder="9876543210"
                    onChange={(e) =>
                      handleChange(
                        "mobile",
                        e.target.value.replace(
                          /\D/g,
                          ""
                        )
                      )
                    }
                    className={inputClass}
                    required
                    pattern="[0-9]{10}"
                  />

                </div>

                {/* EMAIL */}

                <div>

                  <label
                    htmlFor="email"
                    className={labelClass}
                  >
                    Email ID *
                  </label>

                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={form.email}
                    placeholder="john.doe25@example.com"
                    onChange={(e) =>
                      handleChange(
                        "email",
                        e.target.value
                      )
                    }
                    className={inputClass}
                    required
                  />

                </div>

                {/* BIRTH DATE */}

                <div>

                  <label
                    htmlFor="birthDate"
                    className={labelClass}
                  >
                    Birth date *
                  </label>

                  <input
                    id="birthDate"
                    name="birthDate"
                    type="date"
                    value={form.birthDate}
                    onChange={(e) =>
                      handleChange(
                        "birthDate",
                        e.target.value
                      )
                    }
                    className={inputClass}
                    required
                  />

                </div>

                {/* SCHOOL */}

                <div>

                  <label
                    htmlFor="schoolName"
                    className={labelClass}
                  >
                    School name *
                  </label>

                  <input
                    id="schoolName"
                    name="schoolName"
                    type="text"
                    value={form.schoolName}
                    placeholder="Greenfield High School"
                    onChange={(e) =>
                      handleChange(
                        "schoolName",
                        e.target.value
                      )
                    }
                    className={inputClass}
                    required
                  />

                </div>

                {/* CLASS */}

                <div>

                  <label
                    htmlFor="className"
                    className={labelClass}
                  >
                    Class *
                  </label>

                  <select
                    id="className"
                    name="className"
                    value={form.className}
                    onChange={(e) =>
                      handleChange(
                        "className",
                        e.target.value
                      )
                    }
                    className={selectClass}
                    required
                  >

                    <option value="">
                      Select
                    </option>

                    {classList.map((cls) => {

                      const classId =
                        getClassId(cls);

                      const className =
                        getClassName(cls);

                      if (!classId) {
                        return null;
                      }

                      return (
                        <option
                          key={String(classId)}
                          value={String(classId)}
                        >
                          {className}
                        </option>
                      );
                    })}

                  </select>

                </div>

                {/* BOARD */}

                <div>

                  <label
                    htmlFor="board"
                    className={labelClass}
                  >
                    Board *
                  </label>

                  <select
                    id="board"
                    name="board"
                    value={form.board}
                    onChange={(e) =>
                      handleChange(
                        "board",
                        e.target.value
                      )
                    }
                    className={selectClass}
                    required
                  >

                    <option value="">
                      Select
                    </option>

                    <option value="CBSE">
                      CBSE
                    </option>

                    <option value="ICSE">
                      ICSE
                    </option>

                    <option value="State Board">
                      State Board
                    </option>

                  </select>

                </div>

                {/* MEDIUM */}

                <div>

                  <label
                    htmlFor="medium"
                    className={labelClass}
                  >
                    Medium of instruction *
                  </label>

                  <select
                    id="medium"
                    name="medium"
                    value={form.medium}
                    onChange={(e) =>
                      handleChange(
                        "medium",
                        e.target.value
                      )
                    }
                    className={selectClass}
                    required
                  >

                    <option value="">
                      Select
                    </option>

                    <option value="English">
                      English
                    </option>

                    <option value="Hindi">
                      Hindi
                    </option>

                  </select>

                </div>

                {/* PREFERRED BATCH */}

                <div>

                  <label
                    htmlFor="preferredBatch"
                    className={labelClass}
                  >
                    Preferred batch *
                  </label>

                  <select
                    id="preferredBatch"
                    name="preferredBatch"
                    value={form.preferredBatch}
                    onChange={(e) =>
                      handleChange(
                        "preferredBatch",
                        e.target.value
                      )
                    }
                    className={selectClass}
                    required
                  >

                    <option value="">
                      Select
                    </option>

                    <option value="MWF — Mon, Wed, Fri">
                      MWF — Mon, Wed, Fri
                    </option>

                    <option value="TTS — Tue, Thu, Sat">
                      TTS — Tue, Thu, Sat
                    </option>

                  </select>

                </div>

                {/* STATE */}

                <div>

                  <label
                    htmlFor="state"
                    className={labelClass}
                  >
                    State *
                  </label>

                  <input
                    id="state"
                    name="state"
                    type="text"
                    value={form.state}
                    placeholder="Delhi"
                    onChange={(e) =>
                      handleChange(
                        "state",
                        e.target.value
                      )
                    }
                    className={inputClass}
                    required
                  />

                </div>

                {/* CITY */}

                <div>

                  <label
                    htmlFor="city"
                    className={labelClass}
                  >
                    City *
                  </label>

                  <input
                    id="city"
                    name="city"
                    type="text"
                    value={form.city}
                    placeholder="New Delhi"
                    onChange={(e) =>
                      handleChange(
                        "city",
                        e.target.value
                      )
                    }
                    className={inputClass}
                    required
                  />

                </div>

                {/* SECTION */}

                <div>

                  <label
                    htmlFor="Sections"
                    className={labelClass}
                  >
                    Section *
                  </label>

                  <select
                    id="Sections"
                    name="Sections"
                    value={form.Sections}
                    onChange={(e) =>
                      handleChange(
                        "Sections",
                        e.target.value
                      )
                    }
                    className={selectClass}
                    required
                  >

                    <option value="">
                      Select
                    </option>

                    <option value="36">
                      Section 36
                    </option>

                  </select>

                </div>

              </div>

              {/* =================================================
                  DECLARATIONS
              ================================================= */}

              <div className="mt-6 pt-5 border-t border-[#e8dfd0]">

                <p className="mb-3 text-[10px] sm:text-[11px] uppercase tracking-[0.12em] font-semibold text-[#8c84a0]">
                  Declaration by parent or user
                </p>

                {/* TERMS */}

                <label className="flex items-start gap-3 w-full min-h-[46px] px-3 py-2.5 border border-[#dfd4c1] rounded-[9px] bg-white cursor-pointer">

                  <input
                    id="terms"
                    name="terms"
                    type="checkbox"
                    checked={declarations.terms}
                    onChange={(e) =>
                      handleDeclarationChange(
                        "terms",
                        e.target.checked
                      )
                    }
                    required
                    className="mt-[2px] w-4 h-4 accent-[#4035c9] shrink-0"
                  />

                  <span className="text-[10px] sm:text-[11px] leading-5 text-[#625c7d]">
                    I, as a parent or user, agree to
                    InstaED's terms and conditions,
                    privacy policy, and the usage and
                    refund policy.
                  </span>

                </label>

                {/* EDUCATION */}

                <label className="mt-2 flex items-start gap-3 w-full min-h-[46px] px-3 py-2.5 border border-[#dfd4c1] rounded-[9px] bg-white cursor-pointer">

                  <input
                    id="education"
                    name="education"
                    type="checkbox"
                    checked={declarations.education}
                    onChange={(e) =>
                      handleDeclarationChange(
                        "education",
                        e.target.checked
                      )
                    }
                    required
                    className="mt-[2px] w-4 h-4 accent-[#4035c9] shrink-0"
                  />

                  <span className="text-[10px] sm:text-[11px] leading-5 text-[#625c7d]">
                    I, as a parent, agree and allow
                    my child to use this app for
                    educational purposes.
                  </span>

                </label>

                {/* OPTIONAL NOTIFICATION */}

                <label className="mt-2 flex items-start gap-3 w-full min-h-[46px] px-3 py-2.5 border border-[#dfd4c1] rounded-[9px] bg-white cursor-pointer">

                  <input
                    id="notifications"
                    name="notifications"
                    type="checkbox"
                    checked={
                      declarations.notifications
                    }
                    onChange={(e) =>
                      handleDeclarationChange(
                        "notifications",
                        e.target.checked
                      )
                    }
                    className="mt-[2px] w-4 h-4 accent-[#4035c9] shrink-0"
                  />

                  <span className="text-[10px] sm:text-[11px] leading-5 text-[#625c7d]">
                    I opt in to notifications by
                    WhatsApp and SMS, and consent
                    to being contacted by call,
                    WhatsApp or SMS.{" "}

                    <span className="text-[#8c84a0]">
                      Optional.
                    </span>
                  </span>

                </label>

              </div>

              {/* =================================================
                  BUTTONS
              ================================================= */}

              <div className="mt-5 flex flex-col sm:flex-row items-stretch sm:items-center gap-2">

                <button
                  type="submit"
                  disabled={loading}
                  className="h-[40px] px-6 rounded-full bg-[#17144b] text-white text-[13px] font-bold hover:bg-[#27235f] transition disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {loading
                    ? "Creating..."
                    : "Submit"}
                </button>

                <button
                  type="button"
                  onClick={handleFillDemo}
                  disabled={loading}
                  className="h-[40px] px-5 rounded-full border border-[#dfd4c1] bg-white text-[#17144b] text-[13px] font-semibold hover:border-[#4035c9] transition disabled:opacity-60"
                >
                  Fill demo details
                </button>

                <button
                  type="button"
                  onClick={handleReset}
                  disabled={loading}
                  className="h-[40px] px-5 rounded-full border border-transparent text-[#6f6887] text-[13px] font-medium hover:text-[#4035c9] transition"
                >
                  Reset
                </button>

              </div>

            </div>

          </form>

        </main>

        {/* =================================================
            FOOTER
        ================================================= */}

        <footer className="border-t border-[#e8dfd0] py-5 sm:py-6 flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-[10px] sm:text-[11px] text-[#8c84a0]">

          <Link
            to="/terms-condition"
            className="text-[#4035c9] hover:underline"
          >
            Terms of use
          </Link>

          <Link
            to="/policy"
            className="text-[#4035c9] hover:underline"
          >
            Privacy policy
          </Link>

          <span>
            © 2026
          </span>

        </footer>

      </div>

    </div>
  );
};

export default RegisterUser;